import { useMutation, UseMutationResult } from "@tanstack/react-query"
import buildCarrotApiRetryPolicy from "../../../../../../utils/CarrotApiRetryPolicy"
import { carrotClient } from "#/utils/CarrotClient"
import ResponseError from "#/types/responseError"

export default function useMutationMarkScaSetupAsCompleted(): UseMutationResult<void, ResponseError, void, unknown> {
  return useMutation(() => carrotClient.markScaSetupAsCompleted(), {
    retry: buildCarrotApiRetryPolicy(1)
  })
}
